import { useHistory } from "react-router-dom";
import { popModeFromBrowser } from "../services/smokeball-authenticator";
import { AuthContainer } from "../components/Auth/AuthContainer";
import { StartPagePresentational } from "../components/StartPage/StartPagePresentational";
import { NotificationsContainer } from "../components/Notifications/NotificationsContainer";
import { ComponentProps } from "react";
import { showLogin } from "../services/dialog-service";

export const StartPage = () => {
  const history = useHistory();

  const onAuthSuccess = () => {
    const appMode = popModeFromBrowser();
    history.push(`/${appMode}`);
  };

  return <StartPageInjectable {...{ onAuthSuccess, openLoginDialog: showLogin }} />;
};

export const StartPageInjectable = (props: ComponentProps<typeof AuthContainer>) => (
  <div className="m-0 w-full h-full relative">
    <div className="m-0 w-full h-full">
      <NotificationsContainer className="m-2" />
      <div className="flex flex-col flex-grow min-h-0 max-h-full">
        <StartPagePresentational>
          <AuthContainer onAuthSuccess={props.onAuthSuccess} openLoginDialog={props.openLoginDialog} />
        </StartPagePresentational>
      </div>
    </div>
    <div className="absolute bottom-0 left-0 m-4 text-xs font-thin text-neutral-600">1.0.75</div>
  </div>
);
